import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, CardContent, Card, Grid, Button } from '@material-ui/core';
import { faCheckCircle, faClock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useWindowSize } from '../../customHooks/useWindowSize';
import funcTranslateHelper from '../../i18next/funcTranslateHelper';
import { connect } from 'react-redux';
import CertificateGenerator from '../CertificateGenerator';
import MerkleTreeVisualizer from './MerkleTreeVisualizer';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
export const useStyles = makeStyles(theme => ({
  card: {
    width: '100%',
    background: '#FFFFFF',
    boxShadow: '0 5px 28px -6px rgba(60,51,79,0.22)'
  },
  generalText: {
    fontFamily: 'Roboto-Light',
    fontSize: 16,
    color: '#6F6F6F'
  },
  mainTitle: {
    fontFamily: 'Roboto-Bold',
    fontSize: 12,
    color: '#6F6F6F',
    letterSpacing: 0.4,
    textAlign: 'left',
    marginBottom: 4,
    marginTop: 29
  },
  secondaryTitle: {
    fontFamily: 'Roboto-Bold',
    fontSize: 12,
    color: '#6F6F6F',
    letterSpacing: 0.4,
    textAlign: 'left',
    marginBottom: 4,
    marginTop: 4
  },
  hashCode: {
    fontFamily: 'Roboto-Regular',
    fontSize: 16,
    color: '#000000',
    letterSpacing: 0
  }
}));

const SuccessResult = props => {
  const { data: { data }, itemKey, date, itemType } = props;
  const [merkle, setMerkle] = useState(false);

  const size = useWindowSize();
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardContent style={{ padding: 0, display: 'flex' }}>
        {
          merkle
            ? (
              <MerkleTreeVisualizer
                rootHash={data.rootHash}
                txHash={data.tx_hash}
                setMerkle={setMerkle}
              />
            )
            : (
              <Grid
                container
                wrap='nowrap'
                direction={size.width > 375 ? 'row' : 'column'}
              >
                <Grid
                  container
                  item
                  xs={size.width > 600 ? 3 : size.width <= 375 ? 12 : 3}
                  direction='row'
                  alignItems='flex-start'
                  spacing={0}
                  style={{
                    width: '100%',
                    height: '100%',
                    marginBottom: size.width > 375 ? 0 : 25,
                    marginLeft: size.width < 600 && size.width > 375 ? 10 : 0,
                    marginRight: size.width < 600 && size.width > 375 ? 10 : 0
                  }}
                >
                  <Grid
                    container
                    item
                    xs={12}
                    justify='center'
                    alignItems={size.width <= 375 ? 'flex-start' : 'center'}
                    direction='column'
                    style={{
                      marginLeft: size.width <= 375 ? 20 : 0,
                      marginRight: size.width <= 375 ? 20 : 0
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      style={{
                        color: '#42BE65',
                        width: size.width > 600 ? 125.1 : 53.1,
                        height: size.width > 600 ? 125.1 : 53.1,
                        marginTop:
                  size.width > 600 ? 50 : size.width <= 375 ? 12 : 37.1
                      }}
                    />
                    <Typography
                      style={{
                        fontFamily: 'Roboto-Light',
                        fontSize: 14,
                        color: '#AAAAAA',
                        letterSpacing: 0,
                        marginTop: 14.9
                      }}
                    >
                      {funcTranslateHelper('Trazer.Success.certified')}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  item
                  wrap='nowrap'
                  xs={size.width > 600 ? 9 : size.width <= 375 ? 12 : 9}
                  direction='column'
                  style={{
                    textAlign: 'left'
                  }}
                >
                  <Grid
                    item
                    style={{
                      paddingLeft: 10,
                      paddingRight: 10
                    }}
                  >
                    <Typography
                      className={classes.generalText}
                      style={{ marginTop: 26 }}
                    >
                      {funcTranslateHelper('Trazer.Success.certificationEntity')}
                    </Typography>
                    <Typography className={classes.mainTitle}>
                      <b>{funcTranslateHelper(`Trazer.Success.itemType.${itemType}`)}</b>
                    </Typography>
                    <Typography
                      style={{
                        overflowWrap: 'break-word'
                      }}
                      className={classes.hashCode}
                      display='inline'
                    >
                      {itemKey}{' '}
                    </Typography>
                    {size.width > 835 && <br />}
                    <Typography className={classes.generalText} display='inline'>
                      {funcTranslateHelper(`Trazer.Success.actionTaken.${itemType}`)}
                    </Typography>
                    {data.tsa && (
                      <div>
                        {size.width > 835 && <br />}
                        <Typography className={classes.mainTitle}>
                          <b>{funcTranslateHelper('Trazer.Success.tsa.title')}</b>
                        </Typography>
                        <Typography
                          className={classes.secondaryTitle}
                          display={size.width > 740 ? 'inline' : 'block'}
                        >
                          <b>{funcTranslateHelper('Trazer.Success.tsa.time')}</b>
                        </Typography>
                        <Typography
                          className={classes.generalText}
                          display={size.width > 740 ? 'inline' : 'block'}
                        >
                          {data.tsa.time}
                        </Typography>
                      </div>
                    )}
                    <Typography
                      className={classes.generalText}
                      style={{ marginTop: 19 }}
                    >
                      {funcTranslateHelper('Trazer.Success.wasCoded')}
                    </Typography>
                    <Typography className={classes.mainTitle}>
                      <b>{funcTranslateHelper('Trazer.Success.privateTransaction.title')}</b>
                    </Typography>
                    <Typography
                      className={classes.generalText}
                      style={{
                        overflowWrap: 'break-word'
                      }}
                    >
                      {data.tx_hash}
                    </Typography>
                    <Typography
                      className={classes.secondaryTitle}
                      display={size.width > 740 ? 'inline' : 'block'}
                    >
                      <b>{funcTranslateHelper('Trazer.Success.privateTransaction.timestamp')}</b>
                    </Typography>
                    <Typography
                      className={classes.generalText}
                      display={size.width > 740 ? 'inline' : 'block'}
                    >
                      {data.tx_timeStamp}
                    </Typography>
                    {size.width > 740 && <br />}
                    <Typography
                      className={classes.secondaryTitle}
                      display={size.width > 740 ? 'inline' : 'block'}
                    >
                      <b>{funcTranslateHelper('Trazer.Success.privateTransaction.block')}</b>
                    </Typography>
                    <Typography
                      className={classes.generalText}
                      display={size.width > 740 ? 'inline' : 'block'}
                    >
                      {data.tx_block}
                    </Typography>
                    {size.width > 740 && <br />}{' '}
                    <Typography
                      className={classes.secondaryTitle}
                      display={size.width > 740 ? 'inline' : 'block'}
                    >
                      <b>{funcTranslateHelper('Trazer.Success.privateTransaction.confirmations')}</b>
                    </Typography>
                    <Typography
                      className={classes.generalText}
                      display={size.width > 740 ? 'inline' : 'block'}
                    >
                      {data.tx_validations}
                    </Typography>
                    {size.width > 740 && <br />}{' '}
                    <Typography className={classes.mainTitle}>
                      <b>{funcTranslateHelper('Trazer.Success.publicTransaction.title')}</b>
                    </Typography>
                    <Typography
                      className={classes.generalText}
                      style={{ overflowWrap: 'break-word' }}
                    >
                      {data.public_tx_hash}
                    </Typography>
                    <Typography
                      className={classes.secondaryTitle}
                      display={size.width > 740 ? 'inline' : 'block'}
                    >
                      <b>{funcTranslateHelper('Trazer.Success.publicTransaction.timestamp')}</b>
                    </Typography>
                    <Typography
                      className={classes.generalText}
                      display={size.width > 740 ? 'inline' : 'block'}
                    >
                      {data.public_tx_timeStamp}
                    </Typography>
                    {size.width > 740 && <br />}{' '}
                    <Typography
                      className={classes.secondaryTitle}
                      display={size.width > 740 ? 'inline' : 'block'}
                    >
                      <b>{funcTranslateHelper('Trazer.Success.publicTransaction.block')}</b>
                    </Typography>
                    <Typography
                      className={classes.generalText}
                      display={size.width > 740 ? 'inline' : 'block'}
                    >
                      {data.public_tx_block}
                    </Typography>
                    {size.width > 740 && <br />}{' '}
                    <Typography
                      className={classes.secondaryTitle}
                      display={size.width > 740 ? 'inline' : 'block'}
                    >
                      <b>{funcTranslateHelper('Trazer.Success.publicTransaction.confirmations')}</b>
                    </Typography>
                    <Typography
                      className={classes.generalText}
                      display={size.width > 740 ? 'inline' : 'block'}
                    >
                      {data.public_tx_validations}
                    </Typography>
                    {size.width > 740 && <br />}{' '}
                    {data.externalLinks && data.externalLinks.map((link, index) => (
                      <Typography
                        key={index}
                        className={classes.secondaryTitle}
                        style={{ marginTop: 15 }}
                      >
                        <a
                          href={link.url}
                          target='_blank'
                          rel='noopener noreferrer'
                          style={{ color: 'inherit', textDecoration: 'none' }}
                        >
                          {link.name}
                          <OpenInNewIcon
                            style={{
                              fontSize: 15,
                              marginLeft: 5,
                              verticalAlign: 'middle'
                            }}
                          />
                        </a>
                      </Typography>
                    ))}
                    {size.width > 740 && <br />}{' '}
                    <Typography
                      className={classes.generalText}
                      style={{
                        marginTop: 29,
                        marginBottom: size.width > 600 ? 23 : 0
                      }}
                    >
                      {funcTranslateHelper('Trazer.Success.certificateEffect')}
                      {date} UTC
                    </Typography>
                    <Grid
                      container justify='flex-start'
                      alignItems='center'
                    >
                      <Grid item xs>
                        <CertificateGenerator chaincode={itemType} hash={itemKey} data={data} />
                      </Grid>
                      {data.tsa && (
                        <Grid item xs>
                          <Button
                            style={{
                              fontFamily: 'Helvetica',
                              fontSize: 14,
                              color: '#0F62FE',
                              letterSpacing: 0.16,
                              lineHeight: '18 px',
                              border: '1px solid #0F62FE',
                              borderRadius: 0,
                              marginTop: 32,
                              marginBottom: 35,
                              textTransform: 'none'
                            }} onClick={() => downloadBase64File(data.tsa.tsr, data.hash + '.tsr')}
                          >
                            {funcTranslateHelper('Trazer.Success.tsa.button')}
                            <FontAwesomeIcon
                              icon={faClock}
                              style={{
                                color: '#0F62FE',
                                width: 14,
                                height: 14,
                                marginLeft: 22.5,
                                marginRight: 14
                              }}
                            />
                          </Button>
                        </Grid>
                      )}
                      {data.rootHash && (
                        <Grid item xs>
                          <Button
                            onClick={() => setMerkle(true)}
                            style={{
                              fontFamily: 'Helvetica',
                              fontSize: 14,
                              color: '#0F62FE',
                              letterSpacing: 0.16,
                              lineHeight: '18 px',
                              border: '1px solid #0F62FE',
                              borderRadius: 0,
                              marginTop: 32,
                              marginBottom: 35,
                              textTransform: 'none'
                            }}
                          >
                            <p>
                              {funcTranslateHelper('Trazer.Merkletree.merkleproof')}
                            </p>
                            <AccountTreeIcon style={{
                              transform: 'rotate(90deg)',
                              marginLeft: '22px'
                            }}
                            />

                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            )
        }

      </CardContent>
    </Card>

  );
};
const downloadBase64File = (base64Data, fileName) => {
  const linkSource = `data:application/timestamp-reply;base64,${base64Data}`;
  const downloadLink = document.createElement('a');
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
};

const mapStateToProps = state => ({
  configFile: state.configFile
});

export default connect(mapStateToProps, null)(SuccessResult);
